import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { addCmsRoute } from './add-cms-route';

@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = addCmsRoute(inject(Injector));
      return initializerFn();
    }),
  ],
})
export class CmsRouteModule {}
